import { render, staticRenderFns } from "./HexagonSquare.vue?vue&type=template&id=65d4e3fa&"
import script from "./HexagonSquare.vue?vue&type=script&lang=js&"
export * from "./HexagonSquare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports